var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNarration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 777,
    height: 367,
    viewBox: "0 0 777 367",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7553 94.0781H100.363L71.3882 9L187.287 94.0781H742.635C763.239 94.0781 769.463 108.912 770 116.329V336.223C764.849 354.024 749.61 356.729 742.635 355.857H29.5359C14.0827 355.857 8.07314 341.895 7 334.914V115.02C10.8633 100.361 25.7799 94.9507 32.7553 94.0781Z",
    fill: "#FFE9CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7553 94.0781H100.363L71.3882 9L187.287 94.0781H742.635C763.239 94.0781 769.463 108.912 770 116.329V336.223C764.849 354.024 749.61 356.729 742.635 355.857H29.5359C14.0827 355.857 8.07314 341.895 7 334.914V115.02C10.8633 100.361 25.7799 94.9507 32.7553 94.0781Z",
    stroke: "#FF9900",
    strokeWidth: 6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_48",
    x: 0,
    y: 0.936035,
    width: 777,
    height: 366.064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_48"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_48",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNarration);
export default __webpack_public_path__ + "static/media/narration.a7947b4a308aae29134632b9efc5002f.svg";
export { ForwardRef as ReactComponent };